import React from 'react';
import './UniversityExperience.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const UniversityExperience = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="university-experience">
      <div className="university-content">
        <h2 className="university-heading">
          {t.universityTitle}
        </h2>
        
        <div className="university-cards">
          <div className="university-card">
            <div className="university-card-header">
              <h3 className="university-card-title">{t.universityIssai}</h3>
              <div className="university-card-logo">
                <img 
                  src="/logos/logo-issai.png" 
                  alt="ISSAI"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
            <p className="university-card-text">
              {t.universityIssaiText}
            </p>
          </div>
          
          <div className="university-card featured">
            <div className="university-card-header">
              <h3 className="university-card-title">{t.universityAitu}</h3>
              <div className="university-card-logo">
                <img 
                  src="/logos/logo-aitu.png" 
                  alt="AITU"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
            <p className="university-card-text">
              {t.universityAituText1}
            </p>
            <p className="university-card-text">
              {t.universityAituText2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniversityExperience;

